export enum AccountState {
	Locked = "locked",
	Unlocked = "unlocked"
}
